import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NationalityService } from 'src/app/services/nationality.service';
import { NationModel } from '../../register-person/register-person-natinality/nation.model';

@Component({
  selector: 'fun-register-company-partners-address',
  templateUrl: './register-company-partners-address.component.html',
  styleUrls: ['./register-company-partners-address.component.scss'],
})
export class RegisterCompanyPartnersAddressComponent implements OnInit {

  @Output() public sendDataEvent = new EventEmitter<any>();

  constructor(
    public chdRef: ChangeDetectorRef,
    public translate: TranslateService,
    private nationalityService: NationalityService
  ) { }

  public partnerForm: UntypedFormGroup;
  public formControlKeys = [];
  public errorMessages = {};
  public isSubmit = false;
  public errorAmount = false;
  public errorConcept = false;
  public errorDate = false;
  public errorPercent = false;

  countriesList = [];
  countriesLoaded: boolean;

  ngOnInit() {
    this.countriesLoaded = false;
    this.getCountryList();
    this.partnerForm = new UntypedFormGroup({
      residenceAddress: new UntypedFormControl('', [Validators.required]),
      residenceCity: new UntypedFormControl('', [Validators.required]),
      residencePostalCode: new UntypedFormControl('', [Validators.required]),
      residenceRegion: new UntypedFormControl('', [Validators.required]),
      residenceCountry: new UntypedFormControl('', [Validators.required]),
    });
    this.chdRef.detectChanges();
  }

  getInfo() {
    const model = {
      valid: this.partnerForm.valid,
      data: this.partnerForm.value
    }
    this.sendDataEvent.emit(model);
    this.chdRef.detectChanges();
  }

  getCountryList() {
    this.nationalityService.getNations().subscribe(
      (response) => {
        let nations: NationModel[] = response;
        for (let nation of nations) {
          if (nation.code === 108) {
            this.countriesList.unshift({
              id: nation.code,
              name: nation.name,
              flagUrl: `https://flagcdn.com/${nation.isoAlpha2.toLowerCase()}.svg`
            });
          } else {
            this.countriesList.push({
              id: nation.code,
              name: nation.name,
              flagUrl: `https://flagcdn.com/${nation.isoAlpha2.toLowerCase()}.svg`
            });
          }
        }
        this.countriesLoaded = true;
        this.chdRef.detectChanges();
      }
    );
  }

}
